<template>
  <div class=" text-dark  ">

    <!--    <div class="col-12 text-center mb-2">
          <img class="img-fluid col-6 bg-white rounded-circle shadow border profile-site-logo"  :src="findAttributeOnSiteInfo('icon')" alt="">
        </div>-->

    <div class="bg-white profile-box container">
      <div class="row text-center align-items-center py-2 ">

        <div class="col-3">
          <m-a :href="{name:'Profile'}" class="text-dark">
            <img src="../../../../../public/profile.webp" class=" profile-image img-fluid rounded-circle"
                 v-if="$store.getters['User/getProfile'].image == null"/>
            <img v-else class="img-fluid h1  profile-image shadow rounded text-center rounded-circle profile-image"
                 :src="$store.getters['User/getProfile'].image" alt="profile">
          </m-a>
        </div>

        <div class="col-7 ">
          <m-a :href="{name:'Profile'}" class="text-dark">
            <span class="profile-user-name">{{ user.name }} {{ user.last_name }}</span>
          </m-a>
        </div>

        <div class="col-2">
          <b-icon class="curser-pointer" icon="power" @click='logout()'/>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "MenuUserWidget",
  methods: {
    findAttributeOnSiteInfo,
    logout() {
      this.$store.dispatch("Authentication/logout")
    }
  },
  computed: {
    ...mapGetters({
      user: "User/getProfile"
    })
  },

}
</script>

<style scoped>
.profile-user-name {
  font-size: 12px;
}

.profile-box {
  border-radius: 12px;
}

.profile-site-logo {
  aspect-ratio: 1/1;
  object-fit: contain
}
.curser-pointer{
  cursor: pointer;
}
</style>